var devideByMegaBytes = 1024 * 1024;
var devideByKB = 1024;

function Format_YYYYMMDD(array) {
    return array[2] + '-' + array[0] + '-' + array[1];
}

var maxLicenses = 20;